import OneToOneMeetings from "@/modules/oneToOne/views/OneToOneMeetings.vue";
import OneToOneMeeting from "@/modules/oneToOne/views/OneToOneMeeting.vue";

export default [
  {
    path: '/one-to-one/meetings',
    name: 'OneToOneMeetings',
    component: OneToOneMeetings,
    meta: { title: 'Встречи 1:1' },
  },
  {
    path: '/one-to-one/meeting/:id(\\d+)',
    name: 'OneToOneMeeting',
    component: OneToOneMeeting,
    meta: { title: 'Встреча 1:1' },
  },
];